import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const addProductToCartApi = (data) =>
    Promise.resolve(axios.post(endpoints.addToCart, data));
